import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { AccessRange, ActiveInactiveFor, FileUploadFor, KeyValues5, LanguageKeyType, LocalService, PageKey, Status, TriggeredEvent } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';
import { LanguageSelectionComponent } from '../../popups/language-selection/language-selection.component';
import { ToolPricingConfigComponent } from '../../popups/tool-pricing-config/tool-pricing-config.component';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.scss']
})
export class CountriesComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  isCountryConfigOpen = false;
  lstSectionConfigKeys: string[] = ["table"];
  wrappers: KeyValues5[]; selectedCountry = ''; selectedLanguage = ''; selectedCountryId: string;

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private countryManagementService: CountryManagementService, private route: ActivatedRoute, private locationManagementService: LocationManagementService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      file: 'file' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Countries);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  onLoad() {
    this.countryManagementService.getCountries().subscribe(result => {
      this.wrappers = result;
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.countryManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Country).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == strId);
        updatedItem.v5 = updatedItem.v5 == "1" ? "0" : "1";
      }
    });
  }

  openCreateEditPopup(id: string) {
    this.selectedCountryId = id;
    this.isCountryConfigOpen = true;
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        this.selectedCountry = '';
        this.selectedLanguage = '';
        const modalRef = this.modalService.open(LanguageSelectionComponent);
        modalRef.componentInstance.isInnerUsage = true;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.selectedLanguage = result.data;
            this.selectedCountry = key;
            let element = document.getElementById(this.elementIds.file) as HTMLElement;
            if (element)
              element.click();
          }
        });
      } break;
      case 2: {
        const modalRef = this.modalService.open(LanguageSelectionComponent);
        modalRef.componentInstance.isInnerUsage = true;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            let languageId = result.data;
            this.locationManagementService.getLocationFile(key, languageId).subscribe(result => {
              let countryCode = this.localService.countryCodes.find(x => x.key == key).v2;
              this.localService.onDownloadFile(result, 'Locations_' + countryCode + "_" + this.localService.getLanguageCode(languageId));
            });
          }
        });
      } break;
      case 3: {
        const modalRef = this.modalService.open(ToolPricingConfigComponent, { size: 'lg' });
        modalRef.componentInstance.ctryId = key;
        modalRef.componentInstance.isEditMode = true;
      } break;
      case 4: {
        this.languageManagementService.refreshSearchValue(LanguageKeyType.Location, undefined, key).subscribe(result => {
          this.localService.showInformationByStatus(result);
        });
      } break;
      case 5: {
        const modalRef = this.modalService.open(LanguageSelectionComponent);
        modalRef.componentInstance.isInnerUsage = true;
        modalRef.componentInstance.isShowAll = true;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            let languageId = result.data;
            this.languageManagementService.updateAutoTranslationBulk(LanguageKeyType.Location, undefined, key, undefined, languageId).subscribe(result => {
              this.localService.showInformationByStatus(result);
            });
          }
        });
      } break;
    }
  }

  onGenerateRent(locationId: string) {
    let accessRange: AccessRange = AccessRange.Country;
    this.configurationManagementService.generateRent(undefined, locationId, accessRange).subscribe(result => {
      this.localService.showMessageByStatus(result);
    });
  }
}
